/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenModalCreateMutationVariables = {|
  name: string,
  color: string,
|};
export type AllergenModalCreateMutationResponse = {|
  +allergenCreate: ?{|
    +allergen: ?{|
      +id: string,
      +name: string,
      +color: ?string,
      +image: ?string,
    |}
  |}
|};
export type AllergenModalCreateMutation = {|
  variables: AllergenModalCreateMutationVariables,
  response: AllergenModalCreateMutationResponse,
|};
*/


/*
mutation AllergenModalCreateMutation(
  $name: String!
  $color: String!
) {
  allergenCreate(input: {name: $name, color: $color}) {
    allergen {
      id
      name
      color
      image
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "color",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "color",
            "variableName": "color"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AllergenCreatePayload",
    "kind": "LinkedField",
    "name": "allergenCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AllergenNode",
        "kind": "LinkedField",
        "name": "allergen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenModalCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenModalCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenModalCreateMutation(\n  $name: String!\n  $color: String!\n) {\n  allergenCreate(input: {name: $name, color: $color}) {\n    allergen {\n      id\n      name\n      color\n      image\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '205689d20a560b1d1b0381d6520ef6ef';

module.exports = node;
